import { Injectable } from '@angular/core';
import { Router } from "@angular/router";

import {deslocamentosStorage, tiposDeslocamentos, statusDeslocamentos} from "./data.service";

@Injectable()
export class DeslocamentoService {

    constructor(
        private _router: Router
    ) { }

    //session
    setSessionStorage(item: any) {
        let object: string = JSON.stringify(item);
        sessionStorage.setItem(deslocamentosStorage + '-new', object);
    }

    getSessionStorage() {
        let item: string = sessionStorage.getItem(deslocamentosStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(deslocamentosStorage + "-new");
    }

    checkVisitor() {
        const url = this._router.url;
        if (url.indexOf("visitante") === -1) {
            return true;
        }

        return false;
    }

    getTipo(value: number) {
        const tipo = tiposDeslocamentos;
        let x: number, lenX: number;
        for (x = 0, lenX = tipo.length; x < lenX; x++) {
            if (value === tipo[x].Key) {
                value = tipo[x];
                break;
            }
        }

        return value;
    }

    getTipoSaida() {
        return 1;
    }

    getTipoViagem() {
        return 2;
    }

    getStatus(value: number) {
        const status = statusDeslocamentos;
        let x: number, lenX: number;
        for (x = 0, lenX = status.length; x < lenX; x++) {
            if (value === status[x].Key) {
                value = status[x];
                break;
            }
        }

        return value;
    }

    getStatusSolicitado() {
        return 1;
    }

    getStatusCancelado() {
        return 2;
    }

    getStatusAprovado() {
        return 3;
    }

    getStatusConcluido() {
        return 4;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamentos/shared/deslocamento.service.ts
 **/